import { Message , MessageBox  } from 'element-ui';

class RealNameAuthService {
  constructor() {
    this.isChecking = false;
  }

  /**
   * 检查用户是否需要实名认证
   * @param {Object} userInfo - 用户信息
   * @returns {boolean} - 是否需要实名认证
   */
  needRealNameAuth(userInfo) {
    return userInfo && userInfo.isRealNameAuth === false;
  }

  /**
   * 显示实名认证提示
   * @param {Function} onSuccess - 认证成功回调
   * @param {Function} onCancel - 取消认证回调
   */
  showAuthPrompt(onSuccess, onCancel) {
    MessageBox.confirm(
      '根据相关法律法规要求，请完成实名认证后才能正常使用系统功能。',
      '实名认证提醒',
      {
        confirmButtonText: '立即认证',
        cancelButtonText: '稍后再说',
        type: 'warning',
        center: true
      }
    ).then(() => {
      // 用户选择立即认证
      if (onSuccess) {
        onSuccess();
      }
    }).catch(() => {
      // 用户选择稍后再说
      if (onCancel) {
        onCancel();
      }
    });
  }

  /**
   * 检查并提示实名认证
   * @param {Object} userInfo - 用户信息
   * @param {Function} onAuth - 认证回调
   * @param {Function} onSkip - 跳过回调
   */
  checkAndPrompt(userInfo, onAuth, onSkip) {
    if (this.needRealNameAuth(userInfo)) {
      this.showAuthPrompt(onAuth, onSkip);
    }
  }

  /**
   * 在特定功能使用前检查实名认证
   * @param {Object} userInfo - 用户信息
   * @param {string} featureName - 功能名称
   * @param {Function} onAuth - 认证回调
   * @param {Function} onSkip - 跳过回调
   */
  checkBeforeFeature(userInfo, featureName, onAuth, onSkip) {
    if (this.needRealNameAuth(userInfo)) {
      MessageBox.confirm(
        `使用${featureName}功能需要完成实名认证，是否立即认证？`,
        '实名认证提醒',
        {
          confirmButtonText: '立即认证',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        if (onAuth) {
          onAuth();
        }
      }).catch(() => {
        if (onSkip) {
          onSkip();
        }
      });
      return false;
    }
    return true;
  }

  /**
   * 显示实名认证状态
   * @param {boolean} isAuth - 是否已认证
   * @returns {string} - 状态文本
   */
  getAuthStatusText(isAuth) {
    return isAuth ? '已实名认证' : '未实名认证';
  }

  /**
   * 获取实名认证状态标签类型
   * @param {boolean} isAuth - 是否已认证
   * @returns {string} - 标签类型
   */
  getAuthStatusType(isAuth) {
    return isAuth ? 'success' : 'warning';
  }
}

// 创建单例实例
const realNameAuthService = new RealNameAuthService();

export default realNameAuthService; 